import {gql} from '@apollo/client';
import {PodRiskTypeOption} from '../types/PodRiskReviewType';

/**
 * 舆情风险类型字典（按 displayOrder 升序）
 * 文案单一来源为服务端三语，前端按 locale 取 texts 对应 entry.text，改文案无需发前端版本。
 */
export const GET_POD_RISK_TYPE_LIST = gql`
    query GetPodRiskTypeList {
        getPodRiskTypeList {
            code
            displayOrder
            texts {
                lang
                text
            }
        }
    }
`;

export interface GetPodRiskTypeListResponse {
    getPodRiskTypeList: PodRiskTypeOption[];
}
